export default {
  script: [{
    innerHTML: `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
      var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
      j.async=true;
      j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-WM43C7');
    `,
    async: true,
  }],
  noscript: [{
    innerHTML: `
      <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-WM43C7" height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `,
    pbody: true // prepend body (вставить скрипт сразу после тега body)
  }],
  __dangerouslyDisableSanitizers: ['script'],
};
